<p-breadcrumb [model]="breadcrumb"></p-breadcrumb>
<div>
  <h1>Customer Onboarding</h1>
</div>
<main class="solution-doc-type">
  <app-file-explorer *ngIf="showFileExplorer" [displayMode]="FileExplorerDisplay.FileExplorer" [refId]="solMgrFileType" [txnType]="TxnType.SupportFile"
                     [editable]="true" [upload]="false" [documentType]="documentType" [showModifiedDate]="true" [showOwner]="true">
  </app-file-explorer>
</main>
